import { render } from "./ProfileContent.vue?vue&type=template&id=646484d8&ts=true"
import script from "./ProfileContent.vue?vue&type=script&lang=ts"
export * from "./ProfileContent.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__